module.exports = __webpack_public_path__ + "static/media/RishiSharma@2x.c48211a1.png";